<template>
  <v-card-actions>
    <v-card-title class="text_box">
      <div v-for="user in getProjectUsers" :key="user.id">
        <v-chip color="primary" close @click:close="deleteUser(user)">
          {{ user.member_name }}
        </v-chip>
      </div>
    </v-card-title>
  </v-card-actions>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import DEFAULT_CONSTANTS from "@/Utilites/constants";
export default {
  name: "ProjectTeamView",
  props: ["projectUserList"],
  computed: {
    ...mapGetters(["getProjectUsers"]),
  },
  methods: {
    ...mapActions([
      "DeleteProjectUser",
      "showLoadingProcess",
      "closeLoading",
      "showSnackBar",
      "closeSnackBar",
    ]),
    async deleteUser(value) {
      await this.showLoadingProcess();
      try {
        await this.DeleteProjectUser({id: value.id});
        await this.closeLoading();
        await this.showSnackBar({
          text: `${value.member_name} has been deleted from project`,
          color: DEFAULT_CONSTANTS.warn,
        });
        setTimeout(async () => {
          await this.closeSnackBar();
        }, DEFAULT_CONSTANTS.timeout);
      } catch (err) {
        await this.closeLoading();
        await this.showSnackBar({
          text: JSON.stringify(err),
          color: DEFAULT_CONSTANTS.error,
        });
        setTimeout(async () => {
          await this.closeSnackBar();
        }, DEFAULT_CONSTANTS.timeout);
      }
    },
  },
};
</script>

<style scoped>
.text_box {
  background-color: whitesmoke;
  padding: 10px;
  text-align: justify;
  border: 3px solid;
  border-radius: 5px;
}
</style>
